import { Check } from "@/icons";
import { useTranslate } from "@/providers/context";
export const CompleteToast = ({ message }: { message: string }) => {
  const { translate } = useTranslate();
  return (
    <div className="py-[6px] px-2 flex flex-col gap-2 w-[345px]">
      <div className="flex gap-2 items-center p2-semibold">
        <div className="flex h-4 w-4 items-center justify-center rounded-full bg-watchedColor text-white">
          <Check width={13} height={13} />
        </div>
        {translate("Video Marked Complete")}
      </div>
      <div className="p2-medium">{message}</div>
    </div>
  );
};
